export const FORM_PLACEHOLDERS = {
  samlEntityId: 'https://your-app.com/saml',
  samlAcsUrl: 'https://your-app.com/saml/acs',
  samlMetadataUrl: 'https://your-idp.com/saml/metadata',
  metadataXmlUrl: 'https://your-idp.com/metadata.xml',
  oidcDiscoveryUrl: 'https://your-idp.com/.well-known/openid_configuration',
  oidcRedirectUris: 'https://your-app.com/callback, https://your-app.com/auth',

  flowCallbackUrl: 'https://yourapp.com/callback',
  flowSamlEntityId: 'https://yourapp.com/saml',

  enhancedAppBaseUrl: 'https://myapp.company.com',
  enhancedSamlEntityId: 'https://myapp.company.com/saml',
  enhancedSamlAcsUrl: 'https://myapp.company.com/saml/acs',
  enhancedOidcRedirectUris: 'https://myapp.company.com/callback, https://myapp.company.com/auth',
  enhancedContactEmail: 'admin@company.com',

  samlNameIdFormat: 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
  oktaMetadataUrl: 'https://your-domain.okta.com/app/.../sso/saml/metadata',

  igaApiBaseUrl: 'https://api.example.com',
  igaTokenUrl: 'https://auth.example.com/oauth/token',
  igaApiEndpoint: 'https://api.example.com/v1',
  igaMetadataUrl: 'https://api.example.com/metadata',
  igaCallbackUrl: 'https://sailpoint.example.com/callback',
  igaCertificatePem: '-----BEGIN CERTIFICATE-----\n...\n-----END CERTIFICATE-----',
  igaProxyUrl: 'http://proxy.example.com:8080',
  oktaOrgUrl: 'https://your-org.okta.com',
  teamDistributionEmail: 'e.g., sso-team@company.com',
} as const;

